<template>
  <div id="topicsPage" class="pageWrapper">
    <div
      class="pageHeader"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/bg/top-bg-topic-list.jpg') + ')',
      }"
    >
      <div class="container" v-if="this.$store.state.user.user">
        <router-link :to="`/topics/${this.$store.state.user.user.id}`">
          <img
            class="pageHeaderLogo"
            src="@/assets/logo/next-era-white.png"
            alt="VIR Logo"
          />
        </router-link>
      </div>
    </div>

    <div class="pageContent">
      <div class="container">
        <div class="pageContentTitle">Select a Topic</div>
        <div class="pageContentDescription">
          <p>
            You’ve been invited to participate in the VIR Story Capture Program because of your experience with one or more specific topics we’re looking to document in the Archives.
          </p>
          <p>
            You do not need to submit something for every topic, although you’re
            welcome to submit relevant stories or content about any of the
            topics listed. If you’re not sure which topic to choose or have any
            other questions, please
            <a href="mailto:neestories@heritagewerks.com">contact us</a>.
          </p>
        </div>

        <div id="topicListWrapper" v-if="topics">        
          <div class="topicListRow" v-for="topic in topics" :key="topic.id">
            <router-link :to="`/topics/${$route.params.userId}/questions/${topic.id}`">
              <div class="topicListRowHeader">
                <div class="left">
                  <div class="questionAnswerRadio">
                    <span
                      class="questionAnswerRadioCheckmark"
                      v-if="topic.numOfAnswers >= topic.numOfQuestions && topic.numOfQuestions > 0"
                      ><font-awesome-icon icon="check"
                    /></span>
                  </div>
                  <div class="topicNameWrapper">
                    <div class="topicName">{{ topic.title }}</div>
                    <div
                      class="topicStatus"
                      :class="{
                        completed: topic.numOfAnswers >= topic.numOfQuestions && topic.numOfQuestions > 0,
                      }"
                    >
                      <template v-if="topic.numOfAnswers >= topic.numOfQuestions && topic.numOfQuestions > 0">
                        Completed!
                      </template>
                      <template v-else>
                        {{topic.numOfAnswers ? topic.numOfAnswers : 0}} / {{topic.numOfQuestions}}
                        Questions Completed
                      </template>
                    </div>
                  </div>
                </div>
                <div class="right">                
                    <!-- <font-awesome-icon :icon="['fas', 'long-arrow-alt-right']" /> -->
                    <svg width="35" height="19" viewBox="0 0 35 19" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h34.808v18.653H0z"/></defs><g transform="matrix(-1 0 0 1 35 0)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M.007 9.46a1.715 1.715 0 00.025.166l.037.135a.99.99 0 00.013.039l.04.103.026.05a1.196 1.196 0 00.122.2l.026.038c.018.023.036.045.055.066l7.976 7.981c.266.268.621.415.999.415a1.4 1.4 0 00.996-.413 1.4 1.4 0 00.415-1c0-.224-.052-.44-.15-.634v-.1l-5.769-5.769h28.579c.778 0 1.411-.633 1.411-1.411s-.633-1.411-1.411-1.411H4.818l5.503-5.505c.268-.266.416-.62.416-.997 0-.378-.146-.733-.414-1A1.407 1.407 0 009.326 0c-.362 0-.723.138-.998.413L.412 8.328l-.039.042-.015.017c-.025.029-.05.059-.073.09l-.008.01a1.052 1.052 0 00-.08.121 1.107 1.107 0 00-.085.166l-.038.103-.011.035-.031.114a1.156 1.156 0 00-.025.165 1.231 1.231 0 000 .27" fill="#009AD6" mask="url(#b)"/></g></svg>                
                </div>
              </div>
              <div class="topicListRowFooter">
                {{ topic.description }}
              </div>
            </router-link>
          </div>          
          <div class="topicListRow">
            <button @click="onCickFeedback">
              <div class="topicListRowHeader">
                <div class="left">
                  <div class="questionAnswerRadio">
                    
                  </div>
                  <div class="topicNameWrapper">
                    <div class="topicName">Feedback</div>
                    </div>
                </div>
                <div class="right">                
                    <svg width="35" height="19" viewBox="0 0 35 19" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h34.808v18.653H0z"/></defs><g transform="matrix(-1 0 0 1 35 0)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M.007 9.46a1.715 1.715 0 00.025.166l.037.135a.99.99 0 00.013.039l.04.103.026.05a1.196 1.196 0 00.122.2l.026.038c.018.023.036.045.055.066l7.976 7.981c.266.268.621.415.999.415a1.4 1.4 0 00.996-.413 1.4 1.4 0 00.415-1c0-.224-.052-.44-.15-.634v-.1l-5.769-5.769h28.579c.778 0 1.411-.633 1.411-1.411s-.633-1.411-1.411-1.411H4.818l5.503-5.505c.268-.266.416-.62.416-.997 0-.378-.146-.733-.414-1A1.407 1.407 0 009.326 0c-.362 0-.723.138-.998.413L.412 8.328l-.039.042-.015.017c-.025.029-.05.059-.073.09l-.008.01a1.052 1.052 0 00-.08.121 1.107 1.107 0 00-.085.166l-.038.103-.011.035-.031.114a1.156 1.156 0 00-.025.165 1.231 1.231 0 000 .27" fill="#009AD6" mask="url(#b)"/></g></svg>                
                </div>              
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <FeedbackPopup v-if="feedbackStatus" @status = "popupStatus"/>
  </div>
</template>

<script>
import axios from 'axios';
import FeedbackPopup from "@/components/sections/TopicsPage/FeedbackPopup";

export default {
  components: {
    FeedbackPopup
  },
  data() {
    return {      
     topics: null,
     feedbackStatus: null
    };
  },
  methods: {
    onCickFeedback(){
      window.console.log('onCickFeedback');
      this.feedbackStatus = true;
    },
    popupStatus(status){
      this.feedbackStatus = status;
    },
    getTopics(response){
      this.topics = response.data
    },
    init() {
      try {
        axios.get(`user/getTopicsById/${this.$route.params.userId}`).then(this.getTopics);
        

        //window.console.log('getTopicsByIdRes',getTopicsByIdRes);
        
        
        //this.topics.forEach(async topic => {
        //  let getNumOfQuestionsByTopicIdRes = await axios.get(`user/getNumOfQuestionsByTopicId/${topic.id}`);
        //  this.$set(topic, 'numOfQuestions', getNumOfQuestionsByTopicIdRes.data[0].numOfQuestions)

        //  let getNumOfAnswersByTopicIdRes = await axios.get(`user/getNumOfAnswersByTopicId/${topic.id}`);          
        //  this.$set(topic, 'numOfAnswers', getNumOfAnswersByTopicIdRes.data[0].numOfAnswers)

        //});

        //window.console.log(this.topics);
      } catch (e) {
        window.console.log(e);
      }
    }
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.pageContent {
  .pageContentTitle {
    font-family: Effra-Light;
    font-size: 56px;
    color: #009ad6;
    letter-spacing: 0;
    line-height: 54px;
    margin-top: 68px;
  }
  .pageContentDescription {
    font-family: Effra-Regular;
    font-size: 16px;
    color: #5f5f5f;
    letter-spacing: 0;
    line-height: 21px;
    margin-top: 30px;
    p {
      margin-bottom: 20px;
    }
    a {
      color: #009ad6;
    }
  }
  #topicListWrapper {
    margin-top: 40px;
    margin-bottom: 120px;
    .topicListRow {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
      box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
      border-radius: 8px;
      margin-bottom: 15px;
      transition: transform 0.25s ease-in-out;
      user-select: none;
      &:last-child {
        margin-bottom: 15px;
      }
      &:hover {
        transform: translateX(10px);
      }
      a {
        text-decoration: none;
      }
      button{
        border: 0;
        background: transparent;
      }
      .topicListRowHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 30px;
        position: relative;
        .left {
          display: flex;
          align-items: center;

          @media (max-width: $lg) {
            flex-direction: column-reverse;
            align-items: flex-start;
            width: 100%;
          }
          .questionAnswerRadio {
            background-color: #eeeeee;
            box-shadow: inset 0 1px 4px 0 rgba(0, 0, 0, 0.09);
            border-radius: 13px;
            height: 26px;
            width: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;

            @media (max-width: $lg) {
              margin-top: 10px;
            }
            
            .questionAnswerRadioCheckmark {
              background-color: #84bf25;
              width: 16px;
              height: 16px;
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              svg {
                font-size: 10px;
                color: #ffffff;
              }
            }
          }
          .topicNameWrapper {
            .topicName {
              font-family: Effra-Medium;
              font-size: 19px;
              color: #000000;
              letter-spacing: 0;
              line-height: 23px;
            }
            .topicStatus {
              font-family: Effra-Medium;
              font-size: 14px;
              color: #00a0e8;
              letter-spacing: 0;
              line-height: 23px;
              &.completed {
                font-family: Effra-Medium;
                font-size: 14px;
                color: #84bf25;
                letter-spacing: 0;
                line-height: 23px;
              }
            }
          }
        }
        .right {
          @media (max-width: $lg) {
            position: absolute;
            bottom: 25px;
            right: 15px;
          }
          svg {
            font-size: 30px;
            color: #009ad6;
          }          
        }
      }
    }
    .topicListRowFooter {
      font-family: Effra-Regular;
      font-size: 16px;
      color: #5f5f5f;
      letter-spacing: 0;
      line-height: 21px;
      border-top: 1px solid #d8d8d8;
      padding: 18px 30px;
    }
  }
}
</style>